import React, { Component } from 'react';
import ReactPlayer from 'react-player';
import styled, { withTheme } from 'styled-components';

import './global-styles';
import Modal from './Modal';

import Poster from './poster.jpg';
import Video1 from './Teil_1.mp4';
import Video1Back from './Teil_1_Backward.mp4';
import Video2 from './Teil_2.mp4';
import Video2Back from './Teil_2_Backward.mp4';
import Video3 from './Teil_3_Neu.mp4';
import Video3Back from './Teil_3_Neu_Backward.mp4';

import Video1ogv from './Teil_1.ogv';
import Video1Backogv from './Teil_1_Backward.ogv';
import Video2ogv from './Teil_2.ogv';
import Video2Backogv from './Teil_2_Backward.ogv';
import Video3ogv from './Teil_3_Neu.ogv';
import Video3Backogv from './Teil_3_Neu_Backward.ogv';

import Play from './images/play.png';
import ArrowRight from './images/arrow-right.png';
import ArrowLeft from './images/arrow-left.png';
import ArrowDown from './images/arrow-down.png';
import QuestionIcon from './images/quiz.png';
import Quiz1 from './images/quiz-1.png';
import Quiz2 from './images/quiz-2.png';
import Quiz3 from './images/quiz-3.png';
import Quiz4 from './images/quiz-4.png';
import Right1 from './images/spender.png';
import Right2 from './images/Toilettensitzdesinfektion.png';
import Right3 from './images/Toilettenbuersten.png';
import Right4 from './images/Hgienebeutel_eimer.png';
import Left1 from './images/andere-handtuecher.png';
import Left2 from './images/Rollen-Handtuecher.png';
import Left3 from './images/Desinfektionsspender.png';
import Left4 from './images/Seifenspender.png';
import Left5 from './images/Raumduftspender.png';
import Left6 from './images/Abfalleimer.png';

export const StyledApp = styled.div`
  position: relative;
  width: 100vw;
  height: auto;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledVideo = styled.div`
  position: relative;
  width: 100vw;
  max-width: 1920px;
  box-shadow: 0 10px 20px rgba(91, 107, 174, 0.3);

  .video-player {
    width: 100% !important;
    height: 100% !important;

    &.overlay {
      position: absolute;
      left: 0;
      top: 0;
      display: none;

      > div {
        width: 100% !important;
        height: 100% !important;
      }

      &.true {
        display: block;
      }
    }
  }

  .button {
    &.play {
      position: absolute;
      left: 0;
      right: 0;
      margin: -40px auto 0 auto;
      top: 50%;
      z-index: 100;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(255, 255, 255, 0.75);
      width: 80px;
      height: 80px;

      img {
        max-height: 70%;
      }
    }

    &.play-left {
      position: absolute;
      width: 5%;
      height: 51%;
      left: 40%;
      top: 20%;
      background: rgba(255, 255, 255, 0.55);
      z-index: 100;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        max-width: 70%;
      }
    }

    &.play-right {
      position: absolute;
      width: 5%;
      height: 51%;
      left: 56%;
      top: 20%;
      background: rgba(255, 255, 255, 0.55);
      z-index: 100;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        max-width: 70%;
      }
    }

    &.back {
      position: absolute;
      width: 20%;
      height: 6%;
      left: 40%;
      bottom: 0%;
      background: rgba(255, 255, 255, 0.55);
      z-index: 100;

      display: flex;
      align-items: center;
      justify-content: center;

      img {
        max-height: 70%;
      }
    }

    opacity: 0;
    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    cursor: pointer;
    visibility: hidden;

    &.true {
      opacity: 1;
      visibility: visible;
    }
  }

  .tooltip {
    position: absolute;
    max-width: 100%;
    width: 7%;

    &.quiz {
      bottom: 20px;
      right: 20px;
    }

    &.small {
      width: 4%;
    }

    &.action {
      background: rgba(255, 255, 255, 0);
      transition: all 0.6s cubic-bezier(0.645, 0.045, 0.355, 1);
      filter: blur(15px);
      cursor: pointer;

      &:hover {
        background: rgba(255, 255, 255, 0.3);
      }
    }

    &.hoverTogehter {
      &:hover ~ .hoverTogehter {
        background: rgba(255, 255, 255, 0.3);
      }
    }

    img {
      max-width: 100%;
    }
  }
`;

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      playing: false,
      playingStartBack: false,
      playingLeft: false,
      playingRight: false,
      playingLeftBack: false,
      playingRightBack: false,
      playButton: true,
      playLeftRight: false,
      backButton: false,
      loading: true,
      playbackRate: 1,
      quizStep: 1,
      videoStartBack: false,
      videoLeft: false,
      videoRight: false,
      videoLeftBack: false,
      videoRightBack: false,
      infoModal: false,
      quizWidth: 1040,
    };
  }

  componentDidMount() {}

  render() {
    return (
      <StyledApp>
        <StyledVideo>
          <ReactPlayer
            ref={rpStart => (this.rpStart = rpStart)}
            url={[Video1, Video1ogv]}
            playing={this.state.playing}
            className={'video-player'}
            playbackRate={this.state.playbackRate}
            onReady={() => {
              this.setState({ loading: false });
            }}
            onEnded={() => {
              this.setState({
                playing: false,
                playLeftRight: true,
                backButton: true,
              });
            }}
            config={{
              file: {
                attributes: {
                  poster: Poster,
                },
              },
            }}
            playsinline
          />
          <div className={'video-player overlay ' + this.state.videoStartBack}>
            <ReactPlayer
              ref={rpStartBack => (this.rpStartBack = rpStartBack)}
              url={[Video1Back, Video1Backogv]}
              playing={this.state.playingStartBack}
              playbackRate={this.state.playbackRate}
              onEnded={() => {
                this.rpStart.seekTo(0);
                setTimeout(() => {
                  this.rpStartBack.seekTo(0);
                  this.setState({
                    playingStartBack: false,
                    playLeftRight: false,
                    backButton: false,
                    videoStartBack: false,
                    playButton: true,
                  });
                }, 500);
              }}
              playsinline
            />
          </div>
          <div className={'video-player overlay ' + this.state.videoLeft}>
            <ReactPlayer
              ref={rpLeft => (this.rpLeft = rpLeft)}
              url={[Video2, Video2ogv]}
              playing={this.state.playingLeft}
              playbackRate={this.state.playbackRate}
              onEnded={() => {
                this.setState({ playingLeft: false, backButton: true });
              }}
              playsinline
            />
          </div>
          <div className={'video-player overlay ' + this.state.videoLeftBack}>
            <ReactPlayer
              ref={rpLeftBack => (this.rpLeftBack = rpLeftBack)}
              url={[Video2Back, Video2Backogv]}
              playing={this.state.playingLeftBack}
              playbackRate={this.state.playbackRate}
              onEnded={() => {
                this.rpLeft.seekTo(0);
                this.setState({
                  videoLeft: false,
                  videoLeftBack: false,
                  playingLeftBack: false,
                  playLeftRight: true,
                });
                this.rpLeftBack.seekTo(0);
              }}
              playsinline
            />
          </div>
          <div className={'video-player overlay ' + this.state.videoRight}>
            <ReactPlayer
              ref={rpRight => (this.rpRight = rpRight)}
              url={[Video3, Video3ogv]}
              playing={this.state.playingRight}
              playbackRate={this.state.playbackRate}
              onEnded={() => {
                this.setState({ playingRight: false, backButton: true });
              }}
              playsinline
            />
          </div>
          <div className={'video-player overlay ' + this.state.videoRightBack}>
            <ReactPlayer
              ref={rpRightBack => (this.rpRightBack = rpRightBack)}
              url={[Video3Back, Video3Backogv]}
              playing={this.state.playingRightBack}
              playbackRate={this.state.playbackRate}
              onEnded={() => {
                this.rpRight.seekTo(0);
                this.rpRightBack.seekTo(0);
                this.setState({
                  videoRight: false,
                  videoRightBack: false,
                  playingRightBack: false,
                  playLeftRight: true,
                });
              }}
              playsinline
            />
          </div>
          <div
            className={'button play ' + this.state.playButton}
            onClick={() => this.setState({ playing: true, playButton: false })}
          >
            <img src={Play} />
          </div>

          <div
            className={'button play-left ' + this.state.playLeftRight}
            onClick={() => {
              this.setState({
                playLeftRight: false,
                videoLeft: true,
                playingLeft: true,
              });
            }}
          >
            <img src={ArrowLeft} />
          </div>

          <div
            className={'button play-right ' + this.state.playLeftRight}
            onClick={() => {
              this.setState({
                playLeftRight: false,
                videoRight: true,
                playingRight: true,
              });
            }}
          >
            <img src={ArrowRight} />
          </div>

          <div
            className={'button back ' + this.state.backButton}
            onClick={() => {
              if (this.state.videoLeft) {
                this.setState({ videoLeftBack: true, playingLeftBack: true });
              } else if (this.state.videoRight) {
                this.setState({ videoRightBack: true, playingRightBack: true });
              } else {
                this.setState({
                  backButton: false,
                  videoStartBack: true,
                  playingStartBack: true,
                  playLeftRight: false,
                });
              }
            }}
          >
            <img src={ArrowDown} />
          </div>

          <Modal
            visible={this.state.quiz}
            maxWidth={this.state.quizWidth}
            handleClose={() => this.setState({ quiz: false, quizWidth: 1040 })}
          >
            {this.state.quizStep === 1 ? <img src={Quiz1} /> : null}
            {this.state.quizStep === 1 ? (
              <div
                style={{
                  position: 'absolute',
                  left: 0,
                  top: '10%',
                  width: '100%',
                  height: 'calc(100% - 10%)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <div
                  style={{ width: '33.33%', height: '100%' }}
                  onClick={() => this.setState({ quizStep: 3, quizWidth: 958 })}
                />
                <div
                  style={{ width: '33.33%', height: '100%' }}
                  onClick={() => this.setState({ quizStep: 4, quizWidth: 958 })}
                />
                <div
                  style={{ width: '33.33%', height: '100%' }}
                  onClick={() =>
                    this.setState({ quizStep: 2, quizWidth: 1107 })
                  }
                />
              </div>
            ) : null}
            {this.state.quizStep === 2 ? (
              <img
                onClick={() => this.setState({ quizStep: 2, quizWidth: 1107 })}
                src={Quiz2}
              />
            ) : null}
            {this.state.quizStep === 3 ? (
              <img
                onClick={() => this.setState({ quizStep: 1, quizWidth: 1040 })}
                src={Quiz3}
              />
            ) : null}
            {this.state.quizStep === 4 ? (
              <img
                onClick={() => this.setState({ quizStep: 1, quizWidth: 1040 })}
                src={Quiz4}
              />
            ) : null}
          </Modal>

          <Modal
            visible={this.state.infoModal}
            left={this.state.left}
            noPadding
            maxWidth={this.state.imageWidth}
            handleClose={() => this.setState({ infoModal: false })}
          >
            <img src={this.state.image} />
          </Modal>

          <img
            className={'button tooltip quiz ' + this.state.playLeftRight}
            src={QuestionIcon}
            onClick={() => this.setState({ quiz: true, quizStep: 1 })}
          />

          <div
            style={{ top: '11%', right: '23%', height: '35%', width: '10%' }}
            className={
              'button action tooltip ' +
              (this.state.backButton && this.state.videoRight)
            }
            onClick={() =>
              this.setState({
                infoModal: true,
                image: Right1,
                imageWidth: 1129,
                left: -20,
              })
            }
          />

          <div
            style={{ top: '5%', right: '15%', height: '23%', width: '10%' }}
            className={
              'button action tooltip ' +
              (this.state.backButton && this.state.videoRight)
            }
            onClick={() =>
              this.setState({
                infoModal: true,
                image: Right2,
                imageWidth: 816,
                left: -20,
              })
            }
          />

          <div
            style={{ top: '36%', left: '34%', height: '40%', width: '5%' }}
            className={
              'button action tooltip ' +
              (this.state.backButton && this.state.videoRight)
            }
            onClick={() =>
              this.setState({
                infoModal: true,
                image: Right3,
                imageWidth: 855,
                left: 40,
              })
            }
          />

          <div
            style={{ top: '10%', right: '33%', height: '15%', width: '5%' }}
            className={
              'button action tooltip hoverTogehter ' +
              (this.state.backButton && this.state.videoRight)
            }
            onClick={() =>
              this.setState({
                infoModal: true,
                image: Right4,
                imageWidth: 747,
                left: -25,
              })
            }
          />

          <div
            style={{ top: '62%', right: '31%', height: '28%', width: '10%' }}
            className={
              'button action tooltip hoverTogehter ' +
              (this.state.backButton && this.state.videoRight)
            }
            onClick={() =>
              this.setState({
                infoModal: true,
                image: Right4,
                imageWidth: 747,
                left: -25,
              })
            }
          />

          <div
            style={{
              top: '10%',
              right: '33%',
              height: '15%',
              width: '5%',
              pointerEvents: 'none',
            }}
            className={
              'button action tooltip hoverTogehter ' +
              (this.state.backButton && this.state.videoRight)
            }
            onClick={() =>
              this.setState({
                infoModal: true,
                image: Right4,
                imageWidth: 747,
                left: -25,
              })
            }
          />

          <div
            style={{ top: '39%', right: '17%', height: '15%' }}
            className={
              'button action tooltip ' +
              (this.state.backButton && this.state.videoLeft)
            }
            onClick={() =>
              this.setState({
                infoModal: true,
                image: Left1,
                imageWidth: 1328,
                left: -15,
              })
            }
          />
          <div
            style={{ top: '39%', left: '18%', height: '15%' }}
            className={
              'button action tooltip ' +
              (this.state.backButton && this.state.videoLeft)
            }
            onClick={() =>
              this.setState({
                infoModal: true,
                image: Left2,
                imageWidth: 1053,
                left: 10,
              })
            }
          />
          <div
            style={{ top: '40%', left: '7%', height: '12%' }}
            className={
              'button action tooltip small ' +
              (this.state.backButton && this.state.videoLeft)
            }
            onClick={() =>
              this.setState({
                infoModal: true,
                image: Left3,
                imageWidth: 883,
                left: 0,
              })
            }
          />
          <div
            style={{ top: '49%', left: '39.5%', height: '10%' }}
            className={
              'button action tooltip small ' +
              (this.state.backButton && this.state.videoLeft)
            }
            onClick={() =>
              this.setState({
                infoModal: true,
                image: Left4,
                imageWidth: 1066,
                left: 40,
              })
            }
          />
          <div
            style={{ top: '49%', left: '57.5%', height: '10%' }}
            className={
              'button action tooltip small ' +
              (this.state.backButton && this.state.videoLeft)
            }
            onClick={() =>
              this.setState({
                infoModal: true,
                image: Left4,
                imageWidth: 1066,
                left: -40,
              })
            }
          />
          <div
            style={{ top: '18%', left: '19%', height: '10%' }}
            className={
              'button action tooltip small ' +
              (this.state.backButton && this.state.videoLeft)
            }
            onClick={() =>
              this.setState({
                infoModal: true,
                image: Left5,
                imageWidth: 968,
                left: 10,
              })
            }
          />

          <div
            style={{ top: '70%', left: '15%', height: '20%', width: '10%' }}
            className={
              'button action tooltip small ' +
              (this.state.backButton && this.state.videoLeft)
            }
            onClick={() =>
              this.setState({
                infoModal: true,
                image: Left6,
                imageWidth: 829,
                left: 10,
              })
            }
          />

          <div
            style={{ top: '70%', right: '15%', height: '20%', width: '10%' }}
            className={
              'button action tooltip small ' +
              (this.state.backButton && this.state.videoLeft)
            }
            onClick={() =>
              this.setState({
                infoModal: true,
                image: Left6,
                imageWidth: 829,
                left: 10,
              })
            }
          />
        </StyledVideo>
      </StyledApp>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js